import React from 'react';

import style from './index.module.scss';

const RnkimInfo: React.FC = () => (
  <>
    <h1 className={style.header}>Отчет по контрагентам РН+КИМ:</h1>
  </>
);

export default RnkimInfo;
